module.exports = __webpack_public_path__ + "img/1 (80).51874c03.png";